import React from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { lhrcDark } from '../styles/styles';

const NavigationMenu = ({ items }) => {
    return (
        <div className="flex items-center justify-center">
            <ul className={clsx('flex flex-row font-medium mt-0 space-x-12', 'bg-white dark:bg-gray-800')}>
                {items.map((item, index) => (
                    <li key={index}>
                        <NavLink 
                            to={item.to} 
                            className={({ isActive }) => 
                                isActive 
                                    ? 'dark:text-[#41A6D7] text-[#3590BA] flex items-center font-semibold border-b-2 border-[#3590BA] dark:border-[#41A6D7] pb-1 transition-all duration-200' 
                                    : 'dark:text-gray-300 text-gray-600 flex items-center hover:text-[#3590BA] dark:hover:text-[#41A6D7] hover:underline transition-all duration-200'
                            }
                        >
                            <item.icon className="mr-2 stroke-1" />
                            {item.label}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default NavigationMenu;
